angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsWorkspaceTab', function ($log, TeacherDataService, $timeout, TIMING_CONSTANTS) {
  return {
    templateUrl: 'template.html',
    scope: {
      resources: '=',
      students: '=',
      selectedStudents: '=',
      selectedResources: '=',
      selectedClass: '='
    },
    link: function (scope, element) {
      scope.modules = {
        list: [],
        current: null,
        currentChild: null
      };
      scope.selected = {
        resources: {},
        students: {}
      }
      scope.splitResources = {

      };
      scope.splitResourcesTitles = [
        {type: 'lesson', caption: 'Lessons'},
        {type: 'assessment', caption: 'Assessments'},
      ]
      scope.addStudentsToFilter = function(student){
        scope.selectedStudents.push(student)
      }
      scope.toggleResourceSelection = function(resource){
        if(scope.selected.resources[resource.id]){
          delete scope.selected.resources[resource.id];
        }else{
          scope.selected.resources[resource.id] = resource;
        }
        scope.selectedResources = _.map(scope.selected.resources)
      }
      scope.toggleStudentSelection = function(student){
        if(scope.selected.students[student.user_id]){
          delete scope.selected.students[student.user_id];
        }else{
          scope.selected.students[student.user_id] = student;
        }
        scope.selectedStudents = _.map(scope.selected.students)
      }
      scope.setSelectedStudent = function(student){
        scope.selected.students = {};
        scope.selected.students[student.user_id] = student;
        scope.selectedStudents = _.map(scope.selected.students)
      }
      scope.tab = {
        current: 'lesson',
        switch: function(tab){
          this.current = tab;
        },
        isActive: function(tab){
          return this.current === tab;
        }
      };

      scope.style = {
        forResource: function(resource){
          if(scope.selected.resources[resource.id]){
            return {
              'background-color': '#f5f5f5'
            }
          }else{
            return {}
          }
        },
        forStudent: function(student){
          if(scope.selected.students[student.user_id]){
            return {
              'background-color': '#f5f5f5'
            }
          }else{
            return {}
          }
        }
      }
      scope.$watch('resources', function(resources){
        if(resources){
          resources.forEach(function(resource){
            if(!scope.splitResources[resource.resource_type]){
              scope.splitResources[resource.resource_type] = [];
            }
            scope.splitResources[resource.resource_type].push(resource);
          })
        }
      })

      scope.$watch('selectedClass', function(classroom){
        if (classroom){
          TeacherDataService.getClassFullModules(classroom.id).then(function(moduleListFlat){
            //console.log('got modules !', moduleListFlat)
            scope.modules.list = moduleListFlat;
            scope.modules.current = scope.modules.list[0];
          })
        }
      });



      scope.selectResource = function(resource, bubbleModuleItem) {
        $timeout(function(){
          //console.log('CLICKED ON RESOURCE : ', resource, bubbleModuleItem)
        }, TIMING_CONSTANTS.INSTANT)
      }
    }
  }
});
